<template>
  <div v-if="!loading">
    <b-form-group
      label="رویداد شامل به ترم های"
      label-for="add-course-semesters"
      class="w-100"
    >
      <validation-provider
        #default="{ errors }"
        name="semesters"
        vid="semesters"
        class="d-flex justify-content-start align-items-center"
      >
        <select-box
          v-model="selectedSemesters"
          multiple
          label="text"
          class="w-100"
          url="semester"
        />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>
    <div v-if="semesters && semesters.length">
      <hr class="my-2" />
      <div
        class="d-flex justify-content-between"
        v-for="(semester, index) in semesters"
        :key="index"
      >
        <span>{{ semester.text }}</span>
        <b-form-group label-for="add-course-semester-vip">
          <b-form-checkbox
            v-model="semester.vip"
            name="check-semester-vip"
            switch
            inline
            :uncheckedValue="0"
            :value="1"
          >
            قابلیت vip
          </b-form-checkbox>
        </b-form-group>
      </div>
    </div>
  </div>
</template>

<script>
import { BFormCheckbox, BListGroupItem, BFormGroup } from "bootstrap-vue";
import SelectBox from "@core/components/select-box/SelectBox.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
export default {
  components: {
    BFormCheckbox,
    BListGroupItem,
    BFormGroup,
    SelectBox,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    propSemesters: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      semesters: [],
      selectedSemesters: [],
      tempSemesters: [],
      loading: false,
    };
  },
  async created() {
    this.loading = true;
    this.tempSemesters = [...this.propSemesters];
    if (this.propSemesters.length) {
      this.selectedSemesters = await this.propSemesters.map((item) => item.id);
    }
    this.loading = false;
  },
  watch: {
    selectedSemesters(newVal) {
      if (newVal.length) {
        if (newVal.findIndex((item) => item.id) > -1) {
          this.setRoadMap(newVal);
        }
      } else {
        this.sessions = [];
      }
    },
    semesters: {
      handler(newVal) {
        this.$emit("input", newVal);
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    async setRoadMap(newVal) {
      if (this.tempSemesters.length) {
        await this.tempSemesters.forEach((tempItem) => {
          newVal.forEach((val) => {
            if (tempItem.id == val.id) {
              val.vip = tempItem.vip;
            }
          });
        });
      } else {
        await newVal.forEach((val) => {
          val.vip = val.vip || 0;
        });
      }
      const notFound = newVal.filter(
        (val) => this.semesters.findIndex((item) => val === item) === -1
      );

      this.semesters.push(...notFound);
      const removedItems = this.semesters.filter(
        (item) => newVal.findIndex((val) => item === val) == -1
      );
      removedItems.map((removedItem) => {
        const index = this.semesters.findIndex((item) => item == removedItem);
        this.semesters.splice(index, 1);
      });
    },
  },
};
</script>

<style></style>
